import styled from 'styled-components';

export const Content = styled.button`
  margin-left: 7px;
  width: 16px;
  height: 16px;
  color: #fff;
  fill: #fff;
  background: url('/images/clip.svg') no-repeat 50% 50%;
  background-size: contain;
  border: 0;

  cursor: pointer;
  transition: 0.2s all ease-in;
  /* border-radius: 5px; */
  /* border: 1px solid #666; */
  background-size: contain;
  &:hover {
    opacity: .6;
  }
`;
